import { h, Component, ComponentChild, ComponentFactory } from 'preact'

const AlertHTML = (state: {
  isVisible: boolean,
  type: string,
  message: ComponentChild
}) => {
  return <div
    role='alert'
    className={`alert alert-${state.type}`}
    style={!state.isVisible ? 'display: none' : ''} >
    {state.message}
  </div>
}

export interface AlertComponentProps {
  isVisibleFor: number,
  component: ComponentFactory<{
    successCallback: (m: string) => void
    errorCallback: (m: string) => void
    alertComponent: ComponentChild
  }>
}

interface State {
  isVisible: boolean,
  message: string,
  type: string,
  isVisibleFor: number
}

class AlertComponent extends Component<AlertComponentProps, State> {
  private timeout: number

  constructor (props: AlertComponentProps) {
    super()
    this.timeout = 0
    this.state = {
      isVisible: false,
      message: '',
      type: '',
      isVisibleFor: props.isVisibleFor ? props.isVisibleFor : 3000
    }
  }

  componentDidUpdate () {
    if (this.state.isVisible) {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() =>
        this.setState({ isVisible: false })
      , this.state.isVisibleFor)
    }
  }

  success (message: string) {
    this.setState({
      isVisible: true,
      message: message || 'Changes applied successfully!',
      type: 'success'
    })
  }

  error (message: string) {
    this.setState({
      isVisible: true,
      message: message || 'Changes could not be applied',
      type: 'danger'
    })
  }

  render (props: AlertComponentProps, state: State) {
    let Component = props.component
    return <Component
      {...props}
      successCallback={(e: string) => this.success(e)}
      errorCallback={(e: string) => this.error(e)}
      alertComponent={<AlertHTML {...state} />}
    />
  }
}

export default AlertComponent
